import * as THREE from "three/webgpu";

/** Shared four-step light ramp so every character reads as the same authored toon style. */
export function createToonGradient(): THREE.DataTexture {
  const texture = new THREE.DataTexture(
    new Uint8Array([48, 112, 188, 255]),
    4,
    1,
    THREE.RedFormat,
    THREE.UnsignedByteType,
  );
  texture.name = "Pajama four-step toon ramp";
  texture.minFilter = THREE.NearestFilter;
  texture.magFilter = THREE.NearestFilter;
  texture.generateMipmaps = false;
  texture.unpackAlignment = 1;
  texture.needsUpdate = true;
  return texture;
}
